import { render, staticRenderFns } from "./OneImage.vue?vue&type=template&id=46b16f2c&scoped=true&"
import script from "./OneImage.vue?vue&type=script&lang=js&"
export * from "./OneImage.vue?vue&type=script&lang=js&"
import style0 from "./OneImage.vue?vue&type=style&index=0&id=46b16f2c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b16f2c",
  null
  
)

export default component.exports